import wixUsers from 'wix-users';
import wixLocation from 'wix-location';

$w.onReady(function () {

});

export function btnSubmit_click(event) {
    let terms = $w('#terms').checked;
    if (terms) {
        let email = $w('#email').value;
        let password = $w('#password').value;
        wixUsers.register(email, password)
            .then(() => {
    			wixLocation.to('/createPetition/' + wixUsers.currentUser.id);
        });
    } else {
        $w('#txtError').show();
    }
}